import { BehaviorSubject, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { Service } from '../../../../symphony';

import { MailingApiService } from './mailing-api.service';
import { IContactMailData, IPrivacyRequestData, ITeamsRequestData } from '../../../../api/public/mailing-api';

export interface IMailingAction {
	type: MailingActionTypes;
	payload: IPrivacyRequestData | IContactMailData | ITeamsRequestData;
}

export enum MailingActionTypes {
	sendPrivacyRequest = 'sendPrivacyRequest',
	sendContactMail = 'sendContactMail',
	sendTeamsRequest = 'sendTeamsRequest',
}

@Service()
export class MailingActionsService {
	public actions$ = new BehaviorSubject<IMailingAction>(null);

	private apiHandlers = new MailingApiService();

	public actionsStream = this.actions$.pipe(
		filter((a) => !!a),
		switchMap((action) => {
			switch (action.type) {
			case MailingActionTypes.sendPrivacyRequest:
				return this.apiHandlers.sendPrivacyRequestHandler(
						action.payload as IPrivacyRequestData,
				);
			case MailingActionTypes.sendContactMail:
				return this.apiHandlers.sendContactMailHandler(
						action.payload as IContactMailData,
				);
			case MailingActionTypes.sendTeamsRequest:
				return this.apiHandlers.sendTeamsRequestHandler(
						action.payload as ITeamsRequestData,
				);
			default:
				return of(action);
			}
		}),
	);
}
